import React, { useEffect, useState } from "react";
import { Select, MenuItem } from "@mui/material";

const SearchFilterBox = ({ handleFilterChange, handleClearFilters, options }) => {
  const [selectedOption, setSelectedOption] = useState(options?.[0]?.value || 1);
  const [selectedLabel, setSelectedLabel] = useState("Mobile");
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const submitClearFilters = () => {
    setSearchQuery('');
    setIsFilterApplied(false);
    handleClearFilters();
  }

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setIsFilterApplied(false);
      handleClearFilters();
    }
  }, [searchQuery]);

  const submitHandler = () => {
    setIsFilterApplied(true);
    const values = {
      filterType: selectedOption,
      searchQuery: searchQuery.trim()
    }
    handleFilterChange(values);
  };

  const handleCategoryChange = (e) => {
    setIsFilterApplied(false);
    setSelectedOption(e.target.value);
  };

  return (
    <div className="flex">
      <Select
        name="option"
        value={selectedOption}
        onChange={(e) => handleCategoryChange(e)}
        displayEmpty
        className="sm:w-24 w-20 pl-2 md:36 rounded-r-none "
        style={{ height: "40px" }}
        sx={{
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#e5e7eb", // gray-200
          },

          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#d1d5db", // gray-300
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--primary-color)", // your theme primary
            borderWidth: "1px",
          },
        }}
        renderValue={(selected) => {
          if (!selected) {
            return (<div
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}>
              Select Option
            </div>);
          }
          let value = options.find((item) => item.value === selected)?.label;
          setSelectedLabel(value);
          return (<div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}>
            {value}
          </div>)
        }}
      >
        <MenuItem value="" disabled>
          Select Option
        </MenuItem>
        {options.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>

      <input
        type="text"
        placeholder={`Search by ${selectedLabel.toLowerCase()}`}
        value={searchQuery}
        maxLength={selectedLabel === "Mobile" ? 10 : undefined}
        //onChange={(e) => setSearchQuery(e.target.value)}
        onChange={(e) => {
          const value =
            selectedLabel === "Mobile"
              ? e.target.value.replace(/\D/g, "")
              : e.target.value;
          setSearchQuery(value);

          if (isFilterApplied) {
            setIsFilterApplied(false);
          }
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && searchQuery.trim() !== "") {
            e.preventDefault();
            submitHandler();
          }
        }}
        className="md:w-52 lg:w-36 xl:w-52 w-44 flex-grow px-3 py-2 h-10 border-y border-gray-200 rounded-none"
      />
      {isFilterApplied === false &&
        <button
          disabled={searchQuery === '' ? true : false}
          onClick={() => submitHandler()}
          className={`md:px-4 px-2 py-2 h-10 border border-gray-200 text-primary-color rounded-e-md hover:bg-gradient-to-r hover:from-primary-color hover:to-[#00A0FF]  hover:text-white justify-center items-center text-sm ${searchQuery === '' ? 'cursor-not-allowed' : 'cursor-pointer'}`}
        >
          Search
        </button>
      }
      {isFilterApplied === true &&
        <button
          onClick={() => submitClearFilters()}
          className={`sm:px-4 px-2 py-2 h-10 border border-gray-300 text-primary-color rounded-e-md hover:bg-primary-color hover:text-white justify-center items-center text-sm cursor-pointer`}
        >
          Clear
        </button>
      }
    </div>
  );
};

export default SearchFilterBox;
